import { createEntityAdapter } from '@reduxjs/toolkit';
import { ReferralTransaction } from '@tacans/shared-marketplace-layer/dist/api/referral';

export const GetTransactionsAdapter = createEntityAdapter<ReferralTransaction>({
    selectId: (transaction) => transaction.txHash,
  });